<c3-config-section-box
  [title]="TP_SECTIONS_INFO['diet'].label"
  [icon]="TP_SECTIONS_INFO['diet'].icon"
>
  <p config-description>{{ TP_SECTIONS_INFO["diet"].description }}</p>

  <div [c3ConfigForm]="this" [c3ConfigFormHideSaveBtn]="true">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ng-container [ngSwitch]="context">
            <div *ngSwitchCase="CTX_GESTATIONAL" class="c3-flex ion-align-items-center">
              <ion-icon
                size="small"
                color="tertiary"
                [src]="'information-outline' | getIcon"
                class="ion-margin-end"
              >
              </ion-icon>
              <span>
                Il modulo dieta viene attivato automaticamente con l'attivazione dell'app.
                L'applicazione suggerirà alla paziente la dieta migliore da seguire.
              </span>
            </div>

            <p *ngSwitchDefault>Il modulo dieta non è disponibile per questo paziente.</p>
          </ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</c3-config-section-box>
